import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import IncompleteDiyStep from '@/plugins/graphql/queries/v2/diy/incomplete-step.gql';
import { ServiceBundleModel } from '@/helpers/entities/models/ServiceBundleModel';
let StepRedirecter = class StepRedirecter extends Vue {
    get requestOnFlight() {
        return this.$apollo.queries.diyIncompleteStep.loading;
    }
    get parsedParamIsAffiliate() {
        if (this.routeIsAffiliateBundle) {
            return this.routeIsAffiliateBundle === 'true';
        }
        return this.isAffiliateBundle;
    }
    dashboardUrl(key) {
        return `/apps/${key}/${this.appUuid}/overview`;
    }
    pageActivationUrl(bundleUuid) {
        return `/diy/${bundleUuid}/apps/${this.appUuid}/connect-your-facebook`;
    }
    choosePlanUrl(bundleUuid) {
        return `/diy/${bundleUuid}/apps/${this.appUuid}/choose-your-plan`;
    }
    customizeMiniAppUrl(bundleUuid, pageUuid) {
        return `/diy/${bundleUuid}/apps/${this.appUuid}/pages/${pageUuid}/customize-mini-app`;
    }
    affiliateDiyRoute(step, bundle) {
        let url = '';
        const params = { appUuid: this.appUuid };
        switch (step) {
            case null:
                url = `affiliate-overview`;
                Object.assign(params, { key: bundle.key, appUUID: this.appUuid });
                break;
            case 1:
                url = `affiliate-your-facebook`;
                Object.assign(params, { step, serviceBundleUuid: bundle.uuid, isAffiliate: 'true' });
                break;
            case 2:
                url = `affiliate-product-setup`;
                Object.assign(params, { step, appUUID: this.appUuid, isAffiliate: 'true', diy: true });
                break;
            case 3:
                url = `affiliate-commission-form`;
                break;
            default:
                break;
        }
        return { name: url, params };
    }
    generateUrlFor(step, pageUuid, bundle) {
        let url = '';
        switch (step) {
            case null:
                url = this.dashboardUrl(bundle.key);
                break;
            case 2:
                url = this.choosePlanUrl(bundle.uuid);
                break;
            case 3:
                url = this.pageActivationUrl(bundle.uuid);
                break;
            case 4:
                url = this.customizeMiniAppUrl(bundle.uuid, pageUuid);
                break;
            default:
                url = '/apps';
        }
        return url;
    }
    redirectTo(step, pageUuid, bundle) {
        if (this.parsedParamIsAffiliate) {
            return this.$router.push(this.affiliateDiyRoute(step, bundle));
        }
        this.$router.push(this.generateUrlFor(step, pageUuid, bundle));
    }
};
__decorate([
    Prop({ type: String, required: true })
], StepRedirecter.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StepRedirecter.prototype, "isAffiliateBundle", void 0);
__decorate([
    Prop({ type: String, default: null })
], StepRedirecter.prototype, "routeIsAffiliateBundle", void 0);
StepRedirecter = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
        },
        apollo: {
            diyIncompleteStep: {
                query: IncompleteDiyStep,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                result({ data }) {
                    const { step, serviceBundle, activePage } = data.diyIncompleteStep;
                    const serviceBundleModel = new ServiceBundleModel(serviceBundle);
                    const activePageUuid = activePage ? activePage.uuid : null;
                    this.redirectTo(step, activePageUuid, serviceBundleModel);
                },
            },
        },
    })
], StepRedirecter);
export default StepRedirecter;
